import(/* webpackMode: "eager" */ "/vercel/path0/src/app/next-gen/page.tsx");
